import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { AncillarySellType, IProduct, MultilanguageName, ReactQueryKey } from "../../types";

interface IGetRatePlanParams {
    pickupDate: string,
    dropoffDate: string,
    pickupLocation: string,
    dropoffLocation: string,
    carGroupCode: string,
    products: IProduct[],
    businessAgreement: string | null
    offerId?: string,
    profileIdList: number[],
    firstEdit: boolean,
    requestDate?: string,
    tenant: string,
    dealer: string
}

export enum AncillarySubtype {
    Delivery = 'DELIVERY',
    Collection = 'COLLECTION',
    AfterhourPickup = 'AFTERHOUR_PICKUP',
    AfterhourDropoff = 'AFTERHOUR_DROPOFF',
    OneWay = 'ONE_WAY',
    StandardCover = 'STANDARD_COVER',
    SuperCover = 'SUPER_COVER',
    // LPP-22290: coperture mutuamente esclusive con SUPER_COVER.
    Scdw = 'SCDW',
    Stp = 'STP',
    None = 'NONE',
    AdditionalDrivers = 'ADDITIONAL_DRIVER',
    UrbanCollection = 'URBAN_COLLECTION',
    UrbanDelivery = 'URBAN_DELIVERY'
}


export interface IGetRatePlanReturn {
    mileageList: {
        value: string,
        products: {
            product: IProduct,
            rateId: number,
            rateName: string,
            rateDescription: string,
            amount: number,
            currency: string
        }[]
    }[],
    ancillaries: {
        ancillaryCode: string,
        name: MultilanguageName,
        ancillaryDescription: string,
        note: string,
        currency: string,
        maxUnits: number,
        mileageNeeded: boolean,
        type?: string,
        subtype: AncillarySubtype,
        packAncillaries?: { subtype?: string }[] | null,
        ancillaryDetails: {
            productCode: string,
            ancillaryId: string,
            sellType: AncillarySellType
            amount: number
        }[],
        passageToCounterNeeded?: boolean | null
    }[],
    offerId: string,
    discountOverprice: number[]
}

export const getRatePlan = async (params: IGetRatePlanParams): Promise<IGetRatePlanReturn> => {
    const response = await axios.post('/booking/instool/rate-plan', params);
    return response.data;
};

export const useRatePlanQuery = (params: IGetRatePlanParams, options?: UseQueryOptions<IGetRatePlanReturn>) => {
    return useQuery<IGetRatePlanReturn>(
        [ReactQueryKey.RatePlan, {tenant: params.tenant as string, dealer: params.dealer as string}],
        () => getRatePlan(params),
        options
    )
};

export const useRatePlanQueryObserver = (params: {tenant: string, dealer: string}) => {
    return useQuery<IGetRatePlanReturn>({
        queryKey: [ReactQueryKey.RatePlan, {tenant: params.tenant as string, dealer: params.dealer as string}],
        enabled: false
    })
};
